module.exports = __webpack_public_path__ + "img/home-live-icon.867884c9.svg";